import { Router } from '@angular/router';
/* eslint-disable @typescript-eslint/no-shadow */
import { LocalStorageService } from './../../local-storage.service';
import { QUESTION_DATA } from './../questionData';
import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {  PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../popover/popover.component';
import { promise } from 'protractor';
import type Swiper from 'swiper';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements AfterViewInit,OnInit {
 // @ViewChild(IonSlides) slider: IonSlides;
  questions = QUESTION_DATA;
  popupData = [];
  progress = 0;

  @ViewChild('swiperContainer', { read: ElementRef  })
  private swiperContainerRef?: ElementRef<HTMLElement>;
  private slider?: Swiper;

  constructor(
    private popoverController: PopoverController,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    this.refreshSwiperRef();
  }

  // Wird vom Template via (swiperinit) aufgerufen
  onSwiperInit(event: Event): void {
    const el = event.target as any;
    this.slider = el?.swiper as Swiper | undefined;
  }

  ngOnInit() {
    // initialize the titles of the questions with their popups
    this.questions.forEach((value, index) => {
      const title = this.questions[index].title;
      //replace infobox part
      if (title.indexOf('[[') > -1 && title.indexOf(']]') > -1) {
        const indexStart = title.indexOf('[[');
        const indexEnd = title.indexOf(']]');
        const linkText = title.substring(indexStart + 2, indexEnd);
        const textBeforeLink = title.substring(0, indexStart);
        const textAfterLink = title.substring(indexEnd + 2, title.length);
        this.popupData[index] = {
          hasPopup: true,
          linkText,
          textBeforeLink,
          textAfterLink,
        };
      } else {
        this.popupData[index] = {
          hasPopup: false,
          text: title,
        };
      }
    });
  }


  ionViewWillEnter() {
    const slider = this.getActiveSlider();

    //load data and scroll to the current question
    let savedAnswers = this.localStorageService.get('questionnaire');
    if (savedAnswers === null) {
      savedAnswers = [];
      this.questions.forEach((value, index) => {
        this.questions[index].answer = null;
      });
    }
    savedAnswers.forEach((element, index) => {
      this.questions[index].answer = element;
    });

    //get index, by counting des saved answers
    const index = savedAnswers.length;
    // slide always to the next question, but not at the last one!
    if(savedAnswers.length === this.questions.length){
      slider.slideTo(index-1);
    }
    else{
      slider.slideTo(index);
    }
    slider.allowSlideNext = false;
    this.slider.allowSlideNext = false;
    this.checkSliderStatus();


  }

  async showInfoPopup(ev: any, text: string) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      cssClass: 'infoBox',
      componentProps: {
        text,
      },
      translucent: true,
    });
    await popover.present();
    const { role } = await popover.onDidDismiss();
  }

  selectItem(index: number, isApproved: boolean) {
      // is this state selected?
      if(this.questions[index].answer === isApproved){
        this.questions[index].answer = null;
      }
      else{
        this.questions[index].answer = isApproved;
        this.storeProgress(index, this.questions[index].answer);
        this.slider.allowSlideNext = true;
      }
  }

  public next = (): void => {
    const slider = this.getActiveSlider();
    if(slider.isEnd){
      this.router.navigate(['/questionnaire/finished']);
    }
    else{
      slider.slideNext();
      this.checkSliderStatus();
      return;
    }
  };


  public last = (): void => {
    this.slider.slidePrev();
  };

  renderHtml(plainText: string) {
    //1. replace \n with <br>
    const html = plainText.replace(/\n/g, '<br>');

    //2. make links
    //const replacePattern = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    //html = html.replace(replacePattern, '<a href="$1" target="_blank">$1</a>');
    return html;

  }

  /*
   *  locks next slide if current slide wasn't answered
   */
   checkSliderStatus() {
    const index = this.slider.activeIndex;
     this.progress = (index + 1) / this.questions.length;
    const questionnaire = this.localStorageService.get('questionnaire');
     if(questionnaire === null || questionnaire[index] === undefined){
      this.slider.allowSlideNext = false;
     }
    else{
      this.slider.allowSlideNext = true;
    }

  }

  toResult(){
    this.localStorageService.set('isFinishedCheck', true);
    this.router.navigate(['/questionnaire/result']);
  };


  storeProgress(index: number, selection: boolean) {
    let questionnaire = this.localStorageService.get('questionnaire');
    //not initialized
    if (questionnaire === null) {
      questionnaire = [];
    }
    questionnaire[index] = selection;
    this.localStorageService.set('questionnaire', questionnaire);
  }

  private refreshSwiperRef(): void {
    const el = this.swiperContainerRef?.nativeElement as any;
    const swiper = el?.swiper as Swiper | undefined;

    // Nur übernehmen, wenn vorhanden und nicht destroyed
    if (swiper && !swiper.destroyed) {
      this.slider = swiper;
    }
  }

  private getActiveSlider(): Swiper | undefined {
    // Falls alte Referenz destroyed ist, neu holen
    if (!this.slider || (this.slider as any).destroyed) {
      this.refreshSwiperRef();
    }
    return this.slider && !(this.slider as any).destroyed ? this.slider : undefined;
  }
}
